import { defineComponent as _defineComponent } from 'vue'

export default /*#__PURE__*/_defineComponent({
  __name: 'ObsoleteSelector',
  emits: ['obsoleteSelection'],
  setup(__props, { emit }) {



function onObsoleteSelection(event: Event) {
  emit('obsoleteSelection', event);
}

return { __sfc: true,emit, onObsoleteSelection }
}

})